import BackArrow from "@/ui/Icons/BackArrow";
import {
  AnimatePresence,
  motion,
  PanInfo,
  useMotionValue,
  useScroll,
  useTransform,
} from "framer-motion";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { FC, useEffect, useState } from "react";
import { useSupabaseClient, useUser } from "@supabase/auth-helpers-react";
import DisLike from "@/ui/Icons/DisLike";
import Heart from "@/ui/Icons/Heart";
import HappyGirl from "@/ui/Icons/HappyGirl";
import Image from "next/image";
import Loader from "@/components/Loaders/Loader";
import BottomNav from "@/components/BottomNav/BottomNav";
import { idAndNameToSlug } from "@/lib/slug";

export default function Calendar() {
  const router = useRouter();
  const supabaseClient = useSupabaseClient();
  const user = useUser();
  const [ignoreRecipes, setIgnoreRecipes] = useState<any[]>([]);
  const [userCalendar, setUserCalendar] = useState<any>([]);
  const [currentItemIndex, setCurrentItemIndex] = useState<number>(0);
  const [date, setDate] = useState<any>("2023-10-30T00:00:00+00:00");

  useEffect(() => {
    if (router?.query?.date) {
      setDate(router?.query?.date);
    }
  }, []);

  useEffect(() => {
    const fetchCalendar = async () => {
      const storedCalender = localStorage.getItem("cal") || ("[]" as any);
      const recommendations =
        localStorage.getItem("recommendations") || ("[]" as any);

      if (JSON.parse(recommendations).length > 1) {
        setUserCalendar(JSON.parse(recommendations));
      } else {
        const { data: feedbackRecipes } = await supabaseClient
          .from("recipe_feedback")
          .select("*");
        // fetch the recipes ids from recommendations
        const feedbacks: any[] = feedbackRecipes?.map((i: any) => {
          return {
            RecipeID: i?.recipe_id?.toString(),
            feedback: i?.swipe_rating,
          };
        }) as any[];

        const { data, error } = await supabaseClient.functions.invoke(
          "user-recommendations",
          {
            body: {
              feedbacks: feedbacks,
              ignore: JSON.parse(storedCalender)?.map((r: any) => r?.recipe_id),
            },
            method: "POST",
          }
        );
        if (error) console.log("error", error);
        else {
          setIgnoreRecipes(storedCalender);
          setUserCalendar(data);
          localStorage.setItem("recommendations", JSON.stringify(data));
          // localStorage.setItem("initialRecommendation", JSON.stringify(data));
        }
      }
    };
    if (user) {
      fetchCalendar();
    } else {
      // router.push("/signin");
    }
  }, [user]);

  return (
    <section className="w-screen h-screen overflow-hidden">
      <div className="mx-auto h-full relative max-w-xl w-full">
        {userCalendar?.[currentItemIndex] || userCalendar.length === 0 ? (
          <CalendarCard
            item={userCalendar?.[currentItemIndex]}
            key={currentItemIndex}
            nextCalendar={() => setCurrentItemIndex((p) => p + 1)}
            urlDate={date}
            ignoreRecipes={ignoreRecipes}
            setIgnoreRecipes={setIgnoreRecipes}
          />
        ) : (
          <div className={"h-screen flex flex-col justify-center"}>
            <div className={"flex justify-center"}>
              <HappyGirl />
            </div>
            <p className={"text-center mt-10"}>That's all for this week!</p>
            <div className={"flex justify-center mt-5"}>
              <Link href={"/"}>Go to Home</Link>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

const CalendarCard: FC<any> = ({
  item,
  nextCalendar,
  urlDate,
  ignoreRecipes,
  setIgnoreRecipes,
}) => {
  const router = useRouter();
  const [cards, setCards] = useState<any[]>([]);
  const supabaseClient = useSupabaseClient();
  const user = useUser();
  const swipeLeft = () => {
    //    remove current recipe and add new recipe in the list
    setCards((p) => {
      if (p?.length === 1) {
        nextCalendar();
      } else if (p?.length === 3) {
        fetchMoreRecipes();
      }
      submitFeedback(false, p?.[0]);
      return p?.slice(0, p?.length - 1);
    });
  };
  const submitFeedback = async (swipe_rating: boolean, recipe: any) => {
    if (user) {
      await supabaseClient.from("recipe_feedback").insert([
        {
          recipe_id: recipe?.id,
          swipe_rating,
          user_id: user?.id,
        },
      ]);
      setIgnoreRecipes((p: any) => {
        return [...p, recipe];
      });
    }
  };

  // const recommendationDate = new Intl.DateTimeFormat("en-US", {
  //   weekday: "short",
  //   month: "short",
  //   day: "numeric",
  // }).format(new Date(item ? item?.date : urlDate));

  const swipeRight = async () => {
    setCards((p) => {
      if (p?.length === 1) {
        nextCalendar();
      } else if (p?.length === 3) {
        fetchMoreRecipes();
      }
      submitFeedback(true, p?.[0]);
      return p?.slice(0, p?.length - 1);
    });
  };

  const fetchMoreRecipes = async () => {
    // fetch all recipes id that already like or disliked
    const { data: feedbackRecipes } = await supabaseClient
      .from("recipe_feedback")
      .select("*");
    // fetch the recipes ids from recommendations
    const feedbacks: any[] = feedbackRecipes?.map((i: any) => {
      return {
        RecipeID: i?.recipe_id?.toString(),
        feedback: i?.swipe_rating,
      };
    }) as any[];
    // @ts-ignore

    try {
      const { data } = await supabaseClient.functions.invoke(
        "user-recommendations",
        {
          body: {
            feedbacks: feedbacks,
            ignore: ignoreRecipes?.map((r: any) => r?.id),
          },
          method: "POST",
        }
      );

      setCards((p) => {
        let newItems = [];
        for (let i = 0; i < data?.length; i++) {
          const existingItem = p.find(
            (cardItem) => cardItem.id === data?.[i]?.id
          );
          if (!existingItem) {
            newItems.push(data?.[i]);
          }
        }
        return [...newItems, ...p];
      });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (cards.length > 1) {
      localStorage.setItem("recommendations", JSON.stringify(cards));
    }
  }, [cards]);

  useEffect(() => {
    if (item && cards?.length <= 5) {
      if (cards.length === 0) {
        setCards([item]);
        const initialRecommendations = localStorage.getItem("recommendations");
        if (initialRecommendations) {
          setCards((p) => {
            let newItems = [];
            const data = JSON.parse(initialRecommendations);
            for (let i = 0; i < data?.length; i++) {
              const existingItem = p.find(
                (cardItem) => cardItem.id === data?.[i]?.id
              );
              if (!existingItem) {
                newItems.push(data?.[i]);
              }
            }
            return [...newItems, ...p];
          });
        }
      }
      fetchMoreRecipes();
    }
  }, [item]);
  return (
    <div className="py-4 h-full">
      <Link href="/search">
        <div className="relative max-w-xl mx-auto px-4 my-2 sm:px-0">
          <div className="relative z-20 flex justify-between items-center h-12 bg-white rounded-2xl overflow-hidden shadow-sm">
            <div className="absolute flex items-center justify-between z-40 w-full h-full px-5">
              {/* <button onClick={() => router.back()}>
              <BackArrow />
            </button> */}
              <h2 className="text-lg flex-grow text-center text-slate-700 font-medium">
                Search 🔍
              </h2>
              {/* <button
              className="text-[#656364] hover:text-slate-800 text-sm"
              onClick={() => {
                nextCalendar();
              }}
            >
              Skip
            </button> */}
            </div>
          </div>
        </div>
      </Link>
      {item ? (
        <div className="flex justify-center items-center max-w-[390px] mx-auto bg-red-500 h-fit">
          <AnimatePresence>
            {cards
              ?.slice(cards?.length > 5 ? cards?.length - 5 : 0)
              ?.map((recipe: any, key: number) => {
                return (
                  <RecipeCard
                    calendarItem={item}
                    key={recipe?.id}
                    cards={cards}
                    recipe={recipe}
                    swipeLeft={swipeLeft}
                    swipeRight={swipeRight}
                  />
                );
              })}{" "}
          </AnimatePresence>
          <>
            <button
              onClick={swipeLeft}
              className="absolute top-2/3 left-0 flex z-50 active:scale-95 transition duration-150 ease-in-out"
            >
              <DisLike />
            </button>
            <button
              onClick={swipeRight}
              className="absolute top-2/3 right-0 flex gap-x-1 z-50 active:scale-95 transition duration-150 ease-in-out"
            >
              <Heart />
            </button>
          </>
        </div>
      ) : (
        <div className="h-full w-full relative flex justify-center">
          <div className="absolute bottom-0 rounded-t-[48px] max-w-[390px] min-w-[390px] min-h-[60vh] h-auto bg-[#F4E7EC] flex justify-center items-center flex-col">
            <Loader />
            <div className={"flex justify-center my-5"}>
              <p>Loading...</p>
            </div>
          </div>
        </div>
      )}
      <BottomNav />
    </div>
  );
};

export function RecipeCard({
  calendarItem,
  swipeLeft,
  swipeRight,
  recipe,
}: any) {
  const router = useRouter();
  const [leaveX, setLeaveX] = useState(0);
  const [showDetails, setShowDetails] = useState(false);

  const motionValue = useMotionValue(0);
  const rotateValue = useTransform(motionValue, [-100, 100], [-10, 10]);
  const opacityValue = useTransform(
    motionValue,
    [-400, -100, 0, 100, 400],
    [0, 1, 1, 1, 0]
  );

  const cardDragEnd = (event: any, info: PanInfo) => {
    if (info.offset.x > 100) {
      // swipe right
      setLeaveX(1000);
      swipeRight();
    }
    if (info.offset.x < -100) {
      // swipe left
      swipeLeft();
      setLeaveX(-1000);
    }
    if (info?.offset?.y < -100) {
      //    show recipe details page
      setShowDetails(true);
      // got to a different page
      router.push(
        `/${idAndNameToSlug(recipe?.id, recipe?.name)}?calendar=${
          calendarItem?.id
        }`
      );
    }
    if (info?.offset?.y > 200) {
      // hide recipe details
      setShowDetails(false);
    }
  };

  return (
    <>
      <motion.button
        drag
        dragConstraints={{ left: 0, right: 0, top: 0, bottom: 0 }}
        onDragEnd={cardDragEnd}
        style={{
          opacity: opacityValue,
          rotate: rotateValue,
          x: motionValue,
        }}
        initial={{
          scale: 1,
        }}
        animate={{
          scale: 1.05,
        }}
        exit={{
          x: leaveX,
          opacity: 0,
          transition: { duration: 0.8 },
        }}
        tabIndex={-1}
        className={`absolute bottom-0 cursor-grab rounded-t-[48px] max-w-[390px] min-w-[390px] min-h-60vh h-auto  duration-150 transition-opacity bg-[#F4E7EC] mx-auto mt-28`}
      >
        <div className="flex justify-end h-[63vh] min-h-[60vh] max-w-md flex-col text-center">
          <div className="px-4 mb-auto pt-12">
            <div className="flex items-end justify-center h-auto">
              <h2 className="my-4 h-auto text-2xl text-center font-semibold text-[#434343] line-clamp-2">
                {recipe?.name}
              </h2>
            </div>
            <div className="flex items-center justify-center py-4">
              <span className="flex flex-col items-center text-[#343233] gap-y-2 font-medium">
                {/*<Hat className="w-5 h-5"/>*/}
                <p className="text-[#434343] font-light">Prep</p>
                {recipe?.prepTime ? `${recipe?.prepTime} mins` : "-"}
              </span>
              <span className="w-8 h-px rotate-90 bg-[#D2D0D1] block self-center" />

              <span className="flex flex-col items-center text-[#343233] gap-y-2 font-medium">
                {/*<BowlIcon className="w-6 h-6"/>*/}{" "}
                <p className="text-[#434343] font-light">Cook</p>
                {recipe?.cookTime ? `${recipe?.cookTime} mins` : "-"}
              </span>
              {/*<span className="w-8 h-px rotate-90 bg-[#D2D0D1] block self-center"/>
                            {recipe?.starRating && (
                                <span className="flex flex-col items-center text-[#343233] gap-y-2 font-medium">
                  <Star className="w-6 h-6"/>
                                    {recipe?.starRating}({recipe?.noOfReviews})
                </span>
                            )}*/}
            </div>
            {recipe?.dietTags && (
              <div className="flex flex-wrap justify-center px-4 gap-3 min-h-6rem items-center overflow-hidden">
                {recipe?.dietTags?.slice(0, 3).map((tag: string) => (
                  <span
                    key={tag}
                    className="rounded-xl bg-white px-3 py-2 text-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}
            <p className={"h-auto px-11 line-clamp-3 my-3 mb-6 text-[#434343]"}>
              {recipe?.description}
            </p>
            <Link
              href={`/${idAndNameToSlug(recipe?.id, recipe?.name)}?calendar=${
                calendarItem?.id
              }`}
              className={
                "mt-30 text-white font-medium rounded-xl bg-[#15BC6E] p-5"
              }
            >
              Check Out
            </Link>
          </div>

          <div
            className={`absolute object-cover items-center select-none flex justify-center overflow-hidden rounded-full bg-white -top-40 left-1/2 h-auto w-50 -translate-x-1/2 transform shadow-xlzz ring-gray-50`}
          >
            <Image
              width={200}
              height={200}
              src={recipe?.imageURL}
              className="h-[200px] w-[60vw] max-width-[220px] scale-115"
              alt={recipe?.name}
            />
          </div>
        </div>
        {/*{showDetails ? <Recipe recipe={recipe}/> : ""}*/}
      </motion.button>
    </>
  );
}
